import React, { Component } from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Business Strategy',
        description: 'We help you align technology with business goals through clear planning, process design, and digital roadmaps that drive growth.'
    },
    {
        icon: <FiLayers />,
        title: 'Website Development',
        description: 'Custom websites and web applications built with modern stacks, focused on performance, security, and a great user experience.'
    },
    {
        icon: <FiUsers />,
        title: 'Marketing & Reporting',
        description: 'Data-driven insights and reporting tools so you can measure what matters and make informed decisions for your business.'
    },
    {
        icon: <FiMonitor />,
        title: 'Mobile App Development',
        description: 'Native and cross-platform mobile apps that connect you with your users and streamline operations on the go.'
    }
]

class ServiceTwo extends Component{
    render(){
        let title = 'Our Services',
        description = 'Zeodel Technologies delivers end-to-end software solutions—from strategy and web development to mobile apps and analytics—tailored to your business needs.';
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
